import axiosClient from '../../configs/axios';


class VehicleMasterService {
    // Get list 
    async getVehicleList(params) {
        try {
            const response = await axiosClient.get(
                `/vehicle/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addVehicle(data) {
        try {
            const response = await axiosClient.post('/vehicle/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteVehicle(data) {
        try {
            const response = await axiosClient.put(`/vehicle/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new VehicleMasterService(); 